"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var React = _interopRequireWildcard(require("react"));

var _usePkpass2 = require("../usePkpass");

var _types = require("../../../../types");

var _Field = _interopRequireDefault(require("./field/preview/Field"));

var _reactJss = require("react-jss");

var _Theme = require("../../Theme");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _reactJss.createUseStyles)({
  fields: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: function justifyContent(_ref) {
      var fieldsType = _ref.fieldsType;
      return fieldsType === _types.PkpassFieldsType.HeaderFields ? 'flex-end' : 'space-between';
    },
    minHeight: function minHeight(_ref2) {
      var theme = _ref2.theme;
      return theme.scale * 40;
    },
    paddingBottom: function paddingBottom(_ref3) {
      var theme = _ref3.theme;
      return theme.scale * 10;
    },
    // direction: ({ fieldsType }) =>
    //   fieldsType === PkpassFieldsType.HeaderFields ? 'rtl' : undefined,
    width: function width(_ref4) {
      var fieldsType = _ref4.fieldsType;
      return fieldsType === _types.PkpassFieldsType.PrimaryFields ? '100%' : undefined;
    }
  }
});

var Fields = function Fields(props) {
  var _usePkpass = (0, _usePkpass2.usePkpass)(),
      passStyle = _usePkpass.passStyle,
      pass = _usePkpass.pass,
      onFieldDnD = _usePkpass.onFieldDnD;

  var fieldsType = props.fieldsType;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      dragOver = _React$useState2[0],
      setDragOver = _React$useState2[1];

  var onDragOver = function onDragOver(event) {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(true);
  };

  var onDragLeave = function onDragLeave(event) {
    event.stopPropagation();
    event.preventDefault();
    setDragOver(false);
  };

  var onDrop = function onDrop(event) {
    event.preventDefault();
    event.stopPropagation();
    var droppedIndex = Number(event.dataTransfer.getData('droppedIndex'));
    var droppedFieldsType = event.dataTransfer.getData('droppedFieldsType');
    onFieldDnD(fieldsType, 0, droppedFieldsType, droppedIndex);
    setDragOver(false);
  };

  var theme = (0, _Theme.useTheme)();
  var classes = useStyles({
    theme: theme,
    fieldsType: fieldsType,
    dragOver: dragOver
  });
  var fields = pass[passStyle][fieldsType] || [];

  if (fieldsType === _types.PkpassFieldsType.HeaderFields) {
    fields = fields.reverse();
  }

  return /*#__PURE__*/React.createElement("div", {
    className: classes.fields,
    onDrop: onFieldDnD ? onDrop : undefined,
    onDragOver: onFieldDnD ? onDragOver : undefined,
    onDragLeave: onFieldDnD ? onDragLeave : undefined,
    style: dragOver ? theme.dragOver : undefined
  }, fields.map(function (field, i) {
    var index = fieldsType === _types.PkpassFieldsType.HeaderFields ? fields.length - i - 1 : i;
    return /*#__PURE__*/React.createElement(_Field.default, {
      key: field.key,
      fieldsType: fieldsType,
      fieldIndex: index
    });
  }));
};

var _default = Fields;
exports.default = _default;
//# sourceMappingURL=Fields.js.map